module.exports = __webpack_public_path__ + "img/video-5.fe9be252.png";